angular.module('wbDashboard').controller('MilestoneDeleteControllerAurea', ['$scope', '$uibModal', '$q', 'User', 'Milestone', 'Message', function ($scope, $uibModal, $q, User, Milestone, Message) {

    $scope.delete = {};

    $scope.$watchCollection(function() { return User.getMSandWallet(); }, function(milestones) {
        if (milestones) {
            $scope.milestoneList = [];
            angular.forEach(milestones, function(ms) {
                if (ms.status != 200) {
                    return;
                }
                if ($scope.$stateParams.msId != ms.id) {
                    if (ms.type != 'retirement') {
                        $scope.milestoneList.push(ms);
                    } else if (ms.type == 'retirement') {
                        angular.forEach(ms.accounts, function(account) {
                            if (account.name.indexOf('Personal') >= 0) {
                                $scope.milestoneList.push(ms);
                            }
                        });
                    }
                }
            });
        }

    });

    $scope.$watchCollection(function() { return User.getMilestones($scope.$stateParams.msId); }, function(milestone) {
        if (milestone && !milestone.deletable.is_deletable) {
            Message.set({
                text:"Sorry, unable to delete " + milestone.name + " milestone right now. " + milestone.deletable.reason,
                type: "warning",
                timeout: 10
            });
            $scope.$state.go("base.milestone.overview", {msId:$scope.$stateParams.msId});
        }
    });

    $scope.openMilestoneDeleteConfirm = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'modal-confirm-milestone-delete.tpl.html',
            scope:$scope,
            size: 'md',
            windowClass:'confirm-modal'
        });

        modalInstance.result.then(function (selectedItem) {
            $scope.pageData.sending = true;
            Milestone.delete({
                msId:$scope.$stateParams.msId,
                to_milestone_id: $scope.delete.toMilestone.id
            }).then(function(response) {
                User.retrieveOverview(true);
                User.retrieveMilestones($scope.$stateParams.msId, true);
                User.retrieveActivityPending(true);
            }).then(function(response) {
                $scope.$state.go("base.receipt", { receipt: {
                    "action": "DELETE_MILESTONE",
                    "type": $scope.milestone.type,
                    "milestone_name": $scope.milestone.name,
                    "msId": $scope.milestone.id,
                    "milestone_to_name": $scope.delete.toMilestone.name,
                    "amount": $scope.milestone.metrics.value
                }});
            }).catch(function() {
                Message.set({
                    text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                    type: "danger"
                });
            }).finally(function() {
                $scope.pageData.sending = false;
            });

        }).catch(angular.noop);  //dismissed/cancelled

    };

}]);
